<div class="finance-awards-accelerator-view-part">
	This is finance-awards-accelerator view
</div>